module.exports = __webpack_public_path__ + "img/1435127508.49d43a55.jpg";